// pages/qna/QnAWritePage.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createQnA } from '../../api/deskApi';
import FileUploadComponent from '../../components/common/FileUploadComponent';

interface QnAForm {
    category: string;
    title: string;
    content: string;
}

const QnAWritePage = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState<QnAForm>({
        category: '',
        title: '',
        content: '',
    });
    const [files, setFiles] = useState<File[]>([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const categoryOptions = [
        { code: 'MEMBER', label: '회원' },
        { code: 'SERVICE', label: '서비스' },
        { code: 'PAYMENT', label: '선불' },
        { code: 'BILLING', label: '결제' },
        { code: 'ETC', label: '기타' },
    ];

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        if (!form.category) {
            alert('문의 유형을 선택해주세요.');
            return;
        }

        if (!form.title || !form.content) {
            alert('제목과 내용을 입력해주세요.');
            return;
        }

        if (isSubmitting) return;

        try {
            setIsSubmitting(true);

            const formData = new FormData();
            formData.append('category', form.category);
            formData.append('questionTitle', form.title);
            formData.append('questionContent', form.content);

            // 파일 추가
            files.forEach((file) => {
                if (file) {
                    formData.append('files', file);
                }
            });

            const response = await createQnA(formData);

            if (response.data?.code === '00') {
                alert('문의가 등록되었습니다.');
                const qnaId = response.data.data?.id;
                navigate(`/desk/qna/${qnaId}`);
            } else {
                alert(response.data.message || '등록에 실패했습니다.');
            }
        } catch (error) {
            console.error('Q&A 등록 오류:', error);
            alert('문의 등록 중 오류가 발생했습니다.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="bottom-btn">
                <button type="button" className="btn cancel" onClick={() => navigate(-1)}>
                    이전
                </button>
                <button
                    type="button"
                    className="btn confirm"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? '등록 중...' : '등록'}
                </button>
            </div>

            <main className="container">
                <form className="form-box" onSubmit={(e) => e.preventDefault()}>
                    <section className="bg-white">
                        <fieldset>
                            <legend>1:1 문의 폼</legend>
                            <div className="inner-box">
                                <div className="form-item">
                                    <label htmlFor="category" className="input-tit">
                                        문의유형 선택
                                    </label>
                                    <div className="input-box">
                                        <select
                                            id="category"
                                            name="category"
                                            value={form.category}
                                            onChange={handleInputChange}
                                            disabled={isSubmitting}
                                        >
                                            <option value="" hidden>
                                                문의 유형을 선택하세요
                                            </option>
                                            {categoryOptions.map((option) => (
                                                <option key={option.code} value={option.code}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="form-item">
                                    <label htmlFor="title" className="input-tit">
                                        제목
                                    </label>
                                    <div className="input-box">
                                        <input
                                            id="title"
                                            type="text"
                                            name="title"
                                            value={form.title}
                                            onChange={handleInputChange}
                                            placeholder="문의 제목을 입력하세요"
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="form-item">
                                    <label htmlFor="content" className="input-tit">
                                        내용
                                    </label>
                                    <div className="input-box">
                                        <textarea
                                            id="content"
                                            name="content"
                                            value={form.content}
                                            onChange={handleInputChange}
                                            disabled={isSubmitting}
                                        ></textarea>
                                    </div>
                                </div>

                                {/* 파일 업로드 컴포넌트 */}
                                <FileUploadComponent
                                    files={files}
                                    onFilesChange={setFiles}
                                    disabled={isSubmitting}
                                    maxFiles={3}
                                    maxSize={10}
                                />
                            </div>
                        </fieldset>
                    </section>
                </form>
            </main>
        </>
    );
};

export default QnAWritePage;